import { render, staticRenderFns } from "./record2.vue?vue&type=template&id=1c55d4a0&scoped=true&"
import script from "./record2.vue?vue&type=script&lang=js&"
export * from "./record2.vue?vue&type=script&lang=js&"
import style0 from "./record2.vue?vue&type=style&index=0&id=1c55d4a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c55d4a0",
  null
  
)

export default component.exports